module.exports = __webpack_public_path__ + "img/machine.1cc70221.jpg";